import axios from "../api";
//账号登录
export const login = (username) =>
    axios(
        ticket_url + '/api/seller_login',
        {
            p: "ter",
            username: username,
            password:"111111"
        },
         "POST",
        true
    )
// 获取购票基本信息
export const getMovie = () =>
    axios(
        cinema_url + "/api/ticket/get_today_movie", {
           p:'ter'
        },
        "GET",
        true
    )
// 预约列表
export const OrderList = (api_token = '111111', date) =>
    axios(
        cinema_url + "/api/seller/movie_list", {
            p: "ter",
            api_token,
            date
        },
        "GET",
        true
    );

// 获取座位信息
export const SeatInfo = (film_date_layout_id) =>
    axios(
        cinema_url + "/api/order/seat_info",
        {
            p: "ter",
            film_date_layout_id
        },
        "GET",
        true
    );
// 购票
export const CreateFilmOrder = (film_date_layout_id, ticket_class_string, seat, seat_num) =>
    axios(
        cinema_url + "/api/seller/create_order",
        {
            p: "ter",
            film_date_layout_id,
            ticket_class_string,
            seat,
            seat_num,
            api_token:localStorage.api_token
        },
        "POST",
        true
    );

// 取消订单
export const OrderCancelOrder = (api_token, order_id) =>
    axios(
        cinema_url + "/api/seller/cancel_order", {
            p: "ter",
            api_token,
            order_id
        },
        "POST",
        true
    );
// 售票/取票列表
export const SellerOrderList = (skip = 0, take, api_token, start_date, end_date, order_no, ticket_no, out_trans_no, phone, pay_type) =>
    axios(
        cinema_url + "/api/seller/order_list", {
        p: "ter",
        skip,
        take,
        api_token,
        start_date,
        end_date,
        order_no,
        ticket_no,
        out_trans_no,
        phone,
        pay_type,
    },
        "GET",
        true
    );
//轮询订单状态
export const getOrderStatus = (order_id=1) =>
    axios(
        cinema_url + '/api/ticket/order_status',
        {
            p: "ter",
            order_id,
            api_token:localStorage.api_token
        }
    )
// 获取订单信息
export const OrderInfo = (api_token, order_id) =>
    axios(
        cinema_url + "/api/seller/order_info", {
            p: "ter",
            api_token,
            order_id
        },
        "GET",
        true
    );

// 更新订单状态
export const PayOrder = (order_id, payment_id) =>
    axios(
        cinema_url + "/api/ticket/pay_order_ter", {
            p: "ter",
            order_id,
            payment_id,
        },
        "POST",
        true
    );
export const TicketIn = (order_no) =>
    axios(
        cinema_url + "/api/ticket/ticket_info", {
            p: "ter",
            order_no
        },
        "GET",
        true
    );
// 发送扣款
export const sendPay = (auth_code,api_token) =>
    axios(cinema_url + "/api/ticket/ticket_info", {
        p: "ter",
        auth_code,
        order_id,
        order_no,
        api_token,
        payment_id
    },
        "GET",
        true);
// 取票
export const PickupTicket = (order_id, ticket_no, username=0, deviceno_no=0) =>
    axios(
        cinema_url + "/api/ticket/pickup_ticket", {
            p: "ter",
            order_id,
            ticket_no,
            username,
            deviceno_no
        },
        "POST",
        true
    );



// WEBPACK FOOTER //
// ./src/http/modules/http.js